import { createRef, useEffect, useState } from 'react'
import {
  BUTTONS_LABEL,
  HELPER_TEXT,
  LINKS,
  LOGIN_LABELS,
} from '../../services/authorization-constants'

import { Link } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormHelperText from '@material-ui/core/FormHelperText'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { connect } from 'react-redux'
import { useAppSelector } from 'utils/reduxHelpers'
import eqipment from '../../../../assets/images/eqipment.png'
import logo from '../../../../assets/images/logo.jpg'
import { IMG_ALT } from '../../../../services/constants'
import { withMediaQuery } from '../../../../services/root/root-service'
import actions from '../../services/authorization-actions'
import styles from './style'

const LogInPageComponent = (props) => {
  const {
    classes,
    history,
    location,
    requestMagicLink,
    verifyMagicLink,
    resetLoginErrors,
    magicLinkError,
    verifyError,
    isMobile,
  } = props
  const emailRef = createRef()
  const [isEmailEmpty, setEmailEmpty] = useState(false)
  const [linkSent, setLinkSent] = useState(false)
  const magicLinkSending = useAppSelector(
    (state) => state.authorizationReducer.magicLinkSending
  )

  const token = new URLSearchParams(location.search).get('token')

  const goToDashboard = () => {
    window.location.href = '/#/dashboard'
  }

  useEffect(() => {
    if (token) {
      verifyMagicLink(token, goToDashboard)
    }
    // eslint-disable-next-line
  }, [token])

  const onSubmit = (event) => {
    // stop the native form submission: it would reload the page and abort
    // the magic-link request that is still in flight
    event.preventDefault()

    const email = emailRef.current.value.trim()

    resetLoginErrors()
    setLinkSent(false)

    if (email) {
      setEmailEmpty(false)
      requestMagicLink(email, () => setLinkSent(true))
    } else {
      setEmailEmpty(true)
    }
  }

  const requestNewLink = () => {
    resetLoginErrors()
    setLinkSent(false)
    history.replace('/login')
  }

  const verifyState = (
    <>
      {verifyError ? (
        <>
          <FormHelperText error>{HELPER_TEXT.linkFailed}</FormHelperText>
          <Link
            component="button"
            variant="body2"
            color="textSecondary"
            className={classes.forgotPassword}
            onClick={requestNewLink}
          >
            {LINKS.requestNewLink}
          </Link>
        </>
      ) : (
        <>
          <CircularProgress size={30} />
          <Typography variant="subtitle2" color="textSecondary">
            {HELPER_TEXT.verifyingLink}
          </Typography>
        </>
      )}
    </>
  )

  const requestLinkForm = (
    <form onSubmit={onSubmit} className={classes.form}>
      <Typography variant="subtitle2" color="textSecondary">
        {HELPER_TEXT.magicLinkDescription}
      </Typography>
      <FormHelperText
        error
        className={magicLinkError ? '' : classes.helperTextInvisible}
      >
        {magicLinkError}
      </FormHelperText>
      <TextField
        id="outlined-basic"
        label={LOGIN_LABELS.email}
        type="email"
        required
        error={isEmailEmpty}
        inputRef={emailRef}
        className={classes.loginInput}
        variant="outlined"
      />
      <Button
        variant="contained"
        className={classes.loginButton}
        type="submit"
        color="primary"
        disabled={magicLinkSending}
        endIcon={
          magicLinkSending ? (
            <CircularProgress size={20} color="primary.contrastText" />
          ) : null
        }
      >
        {BUTTONS_LABEL.sendLink}
      </Button>
      {linkSent && (
        <Box bgcolor="warning.main" color="warning.contrastText" p={2}>
          <Typography variant="subtitle1">
            {HELPER_TEXT.magicLinkSent}
          </Typography>
        </Box>
      )}
    </form>
  )

  return (
    <div className={isMobile ? classes.mobileLogin : classes.desktopLogin}>
      <div
        className={
          isMobile ? classes.loginWrapperMobile : classes.loginWrapperDesktop
        }
      >
        <img className={classes.logoImage} src={logo} alt={IMG_ALT.LOGO} />
        {token ? verifyState : requestLinkForm}
      </div>
      {!isMobile && (
        <div className={classes.pictureWrapper}>
          <img
            className={classes.lampPictureWrapper}
            src={eqipment}
            alt={IMG_ALT.ARC_DEVICE}
          />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    magicLinkError: state.authorizationReducer.magicLinkError,
    verifyError: state.authorizationReducer.verifyError,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    requestMagicLink: (email, onSuccess) =>
      dispatch(actions.requestMagicLink(email, onSuccess)),
    verifyMagicLink: (token, onSuccess) =>
      dispatch(actions.verifyMagicLink(token, onSuccess)),
    resetLoginErrors: () => dispatch(actions.resetLoginErrors()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withMediaQuery(LogInPageComponent)))
